__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-live-insights/v2_9_0/";